'use client';

import useSWR from 'swr';

import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { getAuthTokenClient } from '@/utils/helpers';

import { TypeCreditSummary } from '../types';

async function fetchWithHeaders(url: string) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: await getAuthTokenClient(),
  };

  const response = await fetch(url, { headers });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
}

export default function useCreditSummary() {
  const creditSummaryUri = `${API_URLS.PRODUCT_CATALOG_PROXY}/credit_summary`;

  const {
    data: creditSummaryData,
    isLoading: isLoadingCreditSummary,
    error: creditSummaryError,
    mutate: mutateCreditSummary,
  } = useSWR<TypeCreditSummary, Error>(
    creditSummaryUri,
    fetchWithHeaders,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data: creditSummaryData,
    loading: isLoadingCreditSummary,
    error: creditSummaryError,
    mutate: mutateCreditSummary,
  };
}
